// Subscription constants
export const SUBSCRIPTION_PLANS = {
  BASIC: 'basic',
  PLUS: 'plus',
  EX_PLUS: 'ex_plus',
}

export const SUBSCRIPTION_PLAN_NAME_MAP = {
  [SUBSCRIPTION_PLANS.BASIC]: gettext('Basic'),
  [SUBSCRIPTION_PLANS.PLUS]: gettext('Plus'),
  [SUBSCRIPTION_PLANS.EX_PLUS]: gettext('Plus'),
}

export const SUBSCRIPTION_STATUS = {
  ACTIVE: 1,
  CANCELLED: 2,
  EXPIRED: 3,
  CANCEL_REQUESTED: 6,
}
export const SUBSCRIPTION_MODAL_NAMES = {
  ERROR: 'subscription_error',
  ERROR_CANCEL: 'subscription_error_cancel',
  MANAGE_SUBSCRIPTION: 'manage_subscription',
  CANCEL_SUBSCRIPTION_CONFIRM: 'cancel_subscription_confirm',
  CHANGE_PAYMENT_METHOD_SUCCESS: 'change_payment_method_success',
  CHANGE_PAYMENT_METHOD_ERROR: 'change_payment_method_error',
}

export const SUBSCRIPTION_BENEFITS = {
  EXTRA_FREE_ADS: 'extra_free_ads',
  MULTIPLE_CUSTOMER_CARE_CHANNELS: 'multiple_customer_care_channels',
  PRIORITY_CUSTOMER_CARE: 'priority_customer_care',
  DUPLICATE_ADS: 'duplicate_ads',
  FREE_MONTHLY_COUPON: 'free_monthly_coupon',
  EXCLUSIVE_DISCOUNTS: 'exclusive_discounts',
  ADS_DRAFT: 'ads_draft',
}

const BASIC_BENEFITS = {
  [SUBSCRIPTION_BENEFITS.EXTRA_FREE_ADS]: 3,
}

const PLUS_BENEFITS = {
  [SUBSCRIPTION_BENEFITS.EXTRA_FREE_ADS]: 6,
  [SUBSCRIPTION_BENEFITS.MULTIPLE_CUSTOMER_CARE_CHANNELS]: true,
  [SUBSCRIPTION_BENEFITS.PRIORITY_CUSTOMER_CARE]: true,
  [SUBSCRIPTION_BENEFITS.DUPLICATE_ADS]: true,
  [SUBSCRIPTION_BENEFITS.FREE_MONTHLY_COUPON]: true,
  [SUBSCRIPTION_BENEFITS.EXCLUSIVE_DISCOUNTS]: true,
  [SUBSCRIPTION_BENEFITS.ADS_DRAFT]: true,
}

export const DEFAULT_SUBSCRIPTION_PLAN_BENEFITS = {
  [SUBSCRIPTION_PLANS.BASIC]: BASIC_BENEFITS,
  [SUBSCRIPTION_PLANS.PLUS]: PLUS_BENEFITS,
  [SUBSCRIPTION_PLANS.EX_PLUS]: PLUS_BENEFITS,
}

export const SUBSCRIPTION_BILLING_CYCLE = {
  MONTHLY: 'monthly',
  ANNUAL: 'annual',
}

export const SUBSCRIPTION_BILLING_CYCLE_TEXT_MAP = {
  [SUBSCRIPTION_BILLING_CYCLE.MONTHLY]: gettext('month'),
  [SUBSCRIPTION_BILLING_CYCLE.ANNUAL]: gettext('year'),
}
